// @flow
import Resource from 'speed-js-core/src/api/Resource';

export default class PatrolActiveResource extends Resource {
    basePath: string = 'patrols/patrols/active/';

    objectPath: string = 'patrols/patrols/active/{ident}/';
}
